module.exports = __webpack_public_path__ + "media/play_event_notice.f982bc53.mp3";